"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAssets = fetchAssets;
function fetchAssets(urls) {
  urls.forEach(url => {
    fetch(url);
  });
}